import React from 'react';
import styles from './styles/basedOnMetric.module.scss';
import { Text } from '@clockout-dev/design-elements';

/**
 * Single "value + label" cell of the BASED ON row in the Funding
 * Recommendation card (e.g. `1.2k / Active Users`).
 */
function BasedOnMetric({ value, label }) {
    return (
        <div className={styles.metric}>
            <Text size="xl" fontWeight="bold" className={styles.value}>{value}</Text>
            <Text size="xs" className={styles.label}>{label}</Text>
        </div>
    );
}

export default BasedOnMetric;
